export default __webpack_public_path__ + "static/media/cy-rating.56b54d94.png";